<template>
  <div class="page">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'MapLayout'
}
</script>

<style lang="scss" scoped>
  .page {
    height: 100%;
    width: 100%;
  }
</style>